const autoNgTemplateLoaderTemplate1 = require('./supplement-setup.template.html');

'use strict';

import { SOLUTION_TYPE } from '../../modules/shared/constants/user-info/solutionType';

(function () {
    angular
        .module('app.supplementSetup', [])
        .config(supplementSetupConfig);

    supplementSetupConfig.$inject = ['$routeProvider'];

    function supplementSetupConfig($routeProvider) {
        $routeProvider
            .when('/supplement-setup', {
                disableCache: true,
                templateUrl: autoNgTemplateLoaderTemplate1,
                controller: 'SupplementSetupController',
                controllerAs: 'vm',
                resolve: {
                    loginRequired: ['AuthService', function (AuthService) {
                        return AuthService.loginRequired();
                    }]
                },
                pageConfig: {
                    solution: SOLUTION_TYPE.NUTRITION,
                }
            })
    }
})();
